var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 283,
    viewBox: "0 0 404 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2307_32161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1152 258.722C127.849 247.612 165.842 244.87 205.272 253.018C242.258 260.661 280.696 277.311 318.215 281.416C329.006 282.597 340.305 282.681 350.243 278.219C360.181 273.758 368.398 263.766 368.026 252.665C367.741 244.135 362.71 236.673 358.476 229.319C353.172 220.107 348.873 210.288 345.687 200.105C343.83 194.174 342.336 187.964 342.94 181.766C344.459 166.181 358.178 155.366 370.152 145.613C384.04 134.301 394.069 118.616 401.146 101.958C408.223 85.2993 401.327 63.4804 389.33 50.0946C379.552 39.1845 364.269 35.312 349.811 34.8331C320.098 33.8478 299.295 48.1226 270.825 39.3661C257.38 35.2308 245.564 27.0028 233.116 20.3615C201.405 3.44722 164.576 -3.24225 129.113 1.47244C106.932 4.42154 83.4122 13.2661 72.2685 33.1143C64.7543 46.4987 64.1336 63.1309 68.0679 78.0332C70.6366 87.7626 75.0579 97.8705 72.1609 107.504C70.2131 113.981 65.2482 118.975 60.3716 123.56C45.1349 137.889 28.7904 151.32 16.59 168.424C4.39099 185.529 -3.35635 207.39 1.43608 227.99C5.01177 243.359 15.674 256.834 29.6195 263.609C43.565 270.383 59.8722 268.773 74.4026 263.441C85.3408 259.426 74.6606 262.867 89.1138 258.722H89.1152Z",
    fill: "url(#paint0_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.709 281.227C316.639 290.235 234.167 262.01 234.167 262.01C234.167 262.01 232.169 246.49 233.062 243.227C233.953 239.966 336.859 245.836 335.966 253.251C335.128 260.227 337.707 281.227 337.707 281.227H337.709Z",
    fill: "url(#paint1_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92 144.091C145.92 144.091 139.231 142.46 134.327 142.905C129.423 143.349 116.193 145.92 115.004 147.749C113.815 149.578 138.042 158.326 143.988 152.395C149.933 146.464 145.92 144.091 145.92 144.091Z",
    fill: "#71B0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.627 178.421C324.931 172.274 295.979 146.16 279.421 133.369C275.144 130.065 271.708 125.794 269.467 120.883C268.709 119.219 268.19 117.81 268.19 117.134C268.19 114.762 269.787 111.601 270.568 107.249C271.757 100.626 263.533 94.2008 259.965 97.3646C256.398 100.528 259.569 104.086 258.776 105.272C257.983 106.458 262.244 91.4334 249.957 90.2471C237.67 89.0609 217.06 86.6884 216.662 97.7595C216.266 108.831 219.834 117.134 221.815 120.297C223.797 123.461 228.95 137.694 234.498 140.462C237.259 141.839 238.968 145.607 241.236 147.776C232.374 155.105 224.672 160.841 221.418 162.207C213.887 165.371 208.337 199.77 203.582 206.887C198.825 214.004 156.811 210.051 156.415 214.399C156.019 218.749 158.397 223.493 157.604 227.448C156.811 231.402 161.965 236.542 167.909 236.147C173.855 235.752 180.196 234.96 178.214 232.588C176.232 230.215 172.268 223.098 168.305 222.703C164.342 222.308 167.116 221.122 176.629 219.539C186.142 217.958 324.075 209.654 266.602 245.635C265.54 246.3 252.382 242.769 247.23 238.419C242.077 234.069 236.825 230.264 231.723 234.959C228.401 238.016 213.094 227.447 209.922 229.028C206.751 230.609 211.111 233.773 211.507 236.145C211.903 238.518 207.147 234.959 208.336 238.518C209.525 242.077 208.236 245.141 211.011 246.327C213.785 247.514 209.128 249.589 213.488 251.961C217.847 254.334 236.478 265.8 244.404 266.195C252.331 266.59 261.051 265.8 265.412 266.986C269.771 268.172 326.451 267.381 332.397 257.893C338.342 248.403 335.964 186.722 329.622 178.419L329.627 178.421Z",
    fill: "#FFD4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.162 176.417C167.284 157.433 160.801 149 154.84 147.553C153.473 147.222 150.691 147.49 149.488 146.762C148.419 146.114 144.535 147.75 141.462 143.5C140.865 142.675 140.691 141.698 140.382 140.879C140.843 139.75 141.218 138.545 141.462 137.273C142.948 129.563 143.543 129.267 144.137 126.004C144.732 122.743 142.652 119.184 142.057 121.556C141.462 123.929 143.841 110.88 137.598 107.619C131.356 104.357 117.681 103.171 115.897 113.253C114.114 123.336 116.194 127.486 116.194 127.486C116.194 127.486 117.878 137.733 120.257 140.403C120.904 141.129 121.517 142.591 122.82 143.711C122.267 145.973 121.78 148.613 120.207 149.579C116.343 151.951 121.842 170.188 125.707 177.01C127.615 180.377 131.842 177.745 135.918 173.36C143.776 175.298 163.248 179.063 167.324 188.279C171.783 198.362 157.217 206.664 157.217 206.664C157.217 206.664 178.918 203.106 180.403 196.285C181.889 189.465 174.612 177.665 174.161 176.417H174.162Z",
    fill: "#FFD9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.813 157.041C107.166 155.504 107.318 153.797 107.803 152.296C108.587 149.875 110.743 143.523 110.743 140.929C110.743 136.777 111.733 135.492 106.086 132.823C100.438 130.155 87.0608 139.348 84.9791 142.609C82.8988 145.87 83.1623 137.996 80.5205 139.643C78.9065 140.649 75.764 145.87 78.1422 149.429C80.5205 152.988 79.9259 154.767 78.4388 158.029C76.9517 161.29 66.8454 173.153 61.1977 175.821C55.55 178.489 40.9837 224.751 40.3891 232.461C39.7945 240.17 42.0238 244.174 47.6716 243.581C53.3193 242.988 68.3311 238.392 76.0605 232.461C83.79 226.529 92.1374 223.351 94.4908 222.082C98.1576 220.104 103.905 217.634 105.39 216.744C106.876 215.855 107.373 225.178 107.373 225.178L115.233 216.545C115.233 216.545 112.571 210.025 107.748 208.411C103.292 206.919 93.0037 211.108 91.22 211.999C89.4363 212.888 75.4646 219.017 67.8345 220.895C60.4762 222.707 55.5472 225.64 52.2777 227.716C49.0083 229.791 58.52 227.123 62.0875 219.412C65.6549 211.701 66.844 201.916 70.708 198.654C74.5721 195.393 102.515 197.468 101.326 189.164C100.137 180.86 94.0273 180.993 92.6395 175.458C92.2781 174.014 92.525 171.671 93.201 171.62C94.9185 171.488 96.9105 173.132 101.855 165.936C104.306 162.369 105.686 161.933 106.809 157.039L106.813 157.041Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.127 111.601C264.127 111.601 266.802 110.909 266.307 108.536C265.812 106.164 266.703 106.263 265.118 105.571C263.533 104.878 262.74 102.803 264.227 102.012C265.713 101.221 267.993 102.308 268.389 104.384C268.785 106.46 268.685 99.9366 265.812 100.232C262.938 100.528 259.669 101.913 261.749 104.087C263.83 106.261 263.732 111.897 264.127 111.599V111.601Z",
    fill: "#E5B095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.652 122.869C239.472 123.125 238.067 123.067 238.363 120.891C238.66 118.716 242.129 118.223 243.814 117.332C245.498 116.442 240.346 121.879 239.652 122.867V122.869Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.715 125.341C232.481 125.072 230.337 123.166 227.563 123.858C224.788 124.551 228.454 123.958 230.535 124.847C232.616 125.736 233.409 127.417 234.202 130.284C234.995 133.15 236.283 136.412 235.292 137.5C234.302 138.587 231.625 135.326 230.931 133.547C230.238 131.767 229.346 130.383 229.742 129.79C230.138 129.197 227.265 129.197 227.364 127.219C227.463 125.241 226.473 123.958 224.787 123.561C223.103 123.166 220.031 116.741 220.328 114.763C220.625 112.786 220.428 107.449 220.428 107.449C220.428 107.449 218.149 107.943 217.95 109.229C217.752 110.514 218.445 114.073 219.338 115.753C220.229 117.433 228.454 133.644 229.544 135.424C230.633 137.203 232.417 139.476 234.002 140.464C235.587 141.453 241.069 146.035 241.896 146.759C242.722 147.483 245.298 151.536 247.676 151.042C250.054 150.548 251.243 150.942 255.702 146.001C260.161 141.059 263.133 138.389 263.133 138.389C263.133 138.389 252.135 147.78 250.351 148.472C248.567 149.164 245 148.472 244.306 147.286C243.612 146.1 238.658 142.245 237.469 141.849C236.28 141.454 235.785 139.181 236.28 138.488C236.775 137.796 237.568 140.466 239.153 139.873C240.738 139.28 241.828 140.565 242.225 139.577C242.621 138.589 243.55 136.086 244.703 135.722C246.586 135.129 245.892 133.844 245 134.141C244.107 134.438 242.027 138.293 240.937 138.392C239.847 138.491 237.766 138.886 237.568 137.997C237.37 137.108 235.389 128.409 232.712 125.345L232.715 125.341Z",
    fill: "#E5B095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.083 133.051C247.083 133.051 254.119 134.929 254.317 136.016C254.516 137.104 255.11 138.587 255.11 138.587C255.11 138.587 255.904 135.028 254.814 134.83C253.724 134.632 248.174 133.249 247.084 133.051H247.083Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.691 128.983C227.691 128.983 228.697 130.212 230.106 129.266C231.514 128.321 231.111 127.186 231.111 127.186L227.693 128.983H227.691Z",
    fill: "#727495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.186 122.814C243.186 122.814 245.033 123.963 246.077 123.224C247.122 122.485 247.282 120.926 247.282 120.926L243.185 122.814H243.186Z",
    fill: "#727495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.237 121.353C241.013 121.27 242.426 122.802 242.492 123.132C242.558 123.462 243.549 122.21 241.237 121.353Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82 123.597C241.82 123.597 242.038 122.656 242.401 122.221C242.764 121.786 245.96 121.496 247.776 120.12C249.591 118.743 247.413 121.134 246.178 121.569C244.944 122.004 241.82 123.597 241.82 123.597Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.685 126.52C231.713 126.5 231.688 126.458 231.657 126.471C230.781 126.89 229.547 127.914 228.021 128.348C227.014 128.636 226.705 129.533 226.342 129.895C225.979 130.257 228.941 128.547 229.71 128.24C230.799 127.805 231.02 126.985 231.684 126.518L231.685 126.52Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.661 142.441C238.661 142.441 241.714 142.109 243.368 141.354C245.746 140.267 247.062 139.182 248.274 138.19C249.661 137.053 250.553 136.115 251.395 135.917C252.238 135.718 252.535 135.917 251.742 136.262C250.948 136.607 246.935 140.019 245.152 140.809C243.368 141.6 241.584 142.44 239.256 142.884C237.004 143.315 238.216 142.835 238.661 142.44V142.441Z",
    fill: "#E5B095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.211 145.573C244.106 145.747 245.298 144.635 246.642 144.119C247.986 143.603 249.455 143.349 247.94 143.053C246.425 142.757 246.518 142.319 246.925 141.714C247.332 141.108 245.011 142.969 243.479 143.367C241.946 143.764 245.578 143.272 244.21 145.573H244.211Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.175 121.138C237.017 120.981 236.58 119.063 237.373 118.073C238.166 117.085 238.067 117.48 237.868 118.567C237.67 119.655 237.769 117.776 239.058 117.085C240.346 116.393 243.12 115.405 245.498 114.515C247.877 113.626 250.156 114.91 250.156 114.91C250.156 114.91 245.994 115.898 243.814 116.985C241.634 118.072 237.868 121.829 237.175 121.137V121.138Z",
    fill: "url(#paint2_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.693 124.055C229.915 123.834 230.684 123.067 229.297 122.474C227.91 121.881 226.82 122.178 226.82 122.178L228.009 122.771C228.009 122.771 225.73 121.98 224.739 123.265C223.749 124.55 224.046 125.243 224.046 125.243C224.046 125.243 225.631 124.749 227.118 124.255C228.603 123.761 228.802 124.947 229.695 124.056L229.693 124.055Z",
    fill: "url(#paint3_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75 131.834C131.75 131.834 130.462 128.275 130.957 127.089C131.452 125.903 132.246 124.816 134.129 124.223C136.012 123.629 137.729 123.696 137.729 123.696C137.729 123.696 133.633 125.113 133.931 126.397C134.229 127.681 133.535 128.571 135.021 128.968C136.507 129.364 134.13 130.055 133.237 129.857C132.346 129.658 132.444 132.822 131.752 131.834H131.75Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.391 130.352C126.367 127.386 123.56 126.76 122.073 126.859C120.587 126.958 117.581 128.178 117.581 128.178C117.581 128.178 119.563 129.957 121.743 129.858C123.923 129.759 126.697 132.032 126.896 133.318C127.094 134.603 127.589 136.184 127.391 137.074C127.192 137.963 127.687 139.348 129.373 139.447C131.058 139.546 132.841 138.36 132.841 138.36C132.841 138.36 131.652 137.767 130.859 137.569C130.066 137.37 128.58 138.063 128.381 137.569C128.183 137.074 128.481 132.528 128.183 132.131C128.067 131.977 127.518 130.724 127.389 130.352H127.391Z",
    fill: "#EAB695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.869 142.805C129.869 142.805 133.536 141.817 134.031 142.014C134.526 142.212 132.247 143.992 131.852 143.794C131.456 143.595 129.869 142.805 129.869 142.805Z",
    fill: "#EAB695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38 142.709C139.281 143.005 136.506 147.553 133.93 148.244C131.536 148.887 127.192 147.75 124.714 145.576L122.819 143.711C122.819 143.711 122.137 147.75 120.948 148.442C119.759 149.134 118.868 153.384 119.363 156.252C119.859 159.118 127.787 154.867 130.362 153.187C132.939 151.507 136.308 149.826 137.794 147.256C139.279 144.685 139.379 142.709 139.379 142.709H139.38Z",
    fill: "#EAB695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.427 116.414C123.427 116.414 119.661 117.995 118.671 120.961C117.68 123.926 117.283 127.287 118.374 128.275C119.464 129.263 118.869 130.548 118.671 131.34C118.472 132.131 118.275 136.974 120.059 139.544C121.842 142.115 124.419 145.277 124.419 145.277C124.419 145.277 118.672 140.664 117.284 134.008C115.95 127.609 115.005 125.012 114.807 123.728C114.608 122.443 115.103 119.675 117.284 117.896C119.464 116.117 127.589 106.825 123.427 116.414Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.084 140.555C126.084 140.555 126.17 140.491 127.555 140.369C130.165 140.138 130.758 140.007 134.887 138.788C137.657 137.97 132.153 140.706 126.083 140.556L126.084 140.555Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.279 155.096C103.372 154.923 102.518 159.742 102.717 160.862C102.916 161.983 102.189 162.51 101 162.444C99.8105 162.378 99.6118 162.905 100.67 163.301C101.727 163.696 102.85 163.235 103.114 162.51C103.379 161.784 102.818 155.952 103.28 155.096H103.279Z",
    fill: "#C97E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 151.258C105.177 151.305 103.823 152.971 103.56 153.631C103.295 154.29 102.716 159.299 103.135 158.32C103.837 156.686 104.184 154.365 104.699 153.68C105.778 152.249 111.062 150.814 105.74 151.258Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.582 164.305C95.4591 164.041 93.9319 163.069 94.5265 162.806C95.1211 162.542 96.0702 164.042 96.9296 164.305C97.7891 164.569 100.896 165.804 102.024 165.804C103.412 165.804 101.496 166.661 101.034 166.068C100.572 165.475 96.5834 164.305 96.5834 164.305H96.582Z",
    fill: "#B06D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8445 152.795C97.7756 153.07 97.5893 154.193 98.2584 154.309C99.4972 154.521 99.6627 153.433 99.6627 153.433L97.8445 152.795Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4912 165.889C96.4912 165.889 99.2654 166.614 98.7371 166.943C98.2087 167.272 96.7547 166.548 96.4912 165.889Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8223 151.736C95.8223 151.736 97.1769 152.001 98.3661 152.462C99.5552 152.923 100.968 152.96 101.768 152.89C101.768 152.89 100.579 153.747 99.918 153.681C99.2573 153.615 97.0776 152.296 95.8223 151.736Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.123 150.122C102.123 150.122 102.585 149.134 100.273 148.408C97.961 147.683 96.1773 147.815 95.5165 147.947C94.8557 148.08 97.3002 147.881 98.6218 148.541C99.9433 149.2 101.661 151.242 102.123 150.122Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.417 150.683C107.672 150.418 108.729 151.21 107.738 151.342C106.748 151.474 105.261 151.704 105.393 151.177C105.525 150.65 105.313 150.914 106.417 150.683Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0685 159.483C81.372 160.314 81.79 161.097 82.3101 161.814C83.7475 163.793 86.6983 166.984 88.6876 168.528C91.3625 170.604 93.4234 171.577 94.196 171.522C94.8899 171.472 87.606 171.323 85.0802 170.879C82.5529 170.434 84.1724 171.555 81.0506 171.999C77.9288 172.444 79.4821 176.86 78.144 171.67C76.8058 166.481 72.2948 163.624 74.3779 162.773C75.8305 162.18 79.7787 155.953 79.7787 155.953L81.0685 159.483Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8585 147.947C81.8585 147.947 83.4932 145.13 82.453 143.944C81.4129 142.758 80.6693 142.462 80.2237 143.351C79.7782 144.24 81.1149 143.647 81.1149 144.537C81.1149 145.428 81.8585 147.947 81.8585 147.947Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53 110.137C127.629 110.199 126.402 111.405 126.003 112.212C125.406 113.425 125.922 114.325 124.368 114.733C121.544 115.475 120.652 117.106 120.355 118.144C120.059 119.181 120.059 114.882 120.652 114.289C121.245 113.696 119.314 117.699 117.382 119.923C115.45 122.147 115.287 123.15 115.764 126.826C115.996 128.605 116.491 130.845 116.491 130.845C116.491 130.845 112.627 127.336 111.735 119.774C110.843 112.212 108.018 111.471 110.397 109.247C112.775 107.023 114.41 106.133 117.382 102.722C120.355 99.3124 122.436 97.0885 126.895 97.533C131.354 97.9775 134.03 98.8679 134.03 98.8679C134.03 98.8679 132.396 98.2747 131.503 99.3123C130.612 100.35 135.367 99.6082 135.367 99.6082C135.367 99.6082 135.664 100.497 134.773 100.943C133.881 101.388 137.002 100.647 139.826 105.095C142.65 109.543 142.65 119.181 142.65 120.515C142.65 121.848 141.46 122.145 141.609 124.667C141.758 127.188 140.42 115.474 138.786 113.546C137.151 111.618 135.516 107.022 132.691 108.95C130.721 110.294 129.533 110.066 128.529 110.136L128.53 110.137Z",
    fill: "url(#paint4_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.072 128.21C133.072 128.21 133.468 127.123 134.856 126.826C136.244 126.53 138.125 126.53 138.819 125.937C139.513 125.344 137.432 127.222 136.54 127.617C135.649 128.012 133.369 127.617 133.072 128.21Z",
    fill: "url(#paint5_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.683 144.783C85.1272 145.548 83.0924 150.648 85.9784 149.912C90.7032 148.707 87.9759 146.684 95.3094 144.707C102.642 142.729 82.5034 141.026 84.683 144.783Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.178 130.125C125.178 130.125 124.424 129.429 123.048 129.77C121.673 130.111 119.951 130.893 119.104 130.711C118.256 130.53 120.835 131.152 121.794 131.095C122.753 131.039 124.693 129.78 125.18 130.125H125.178Z",
    fill: "url(#paint6_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.437 139.841C111.207 141.109 109.356 140.717 108.168 141.225C104.34 142.859 99.1499 145.08 93.3049 145.575C88.5939 145.973 88.5153 145.904 85.8735 145.18C83.2317 144.455 83.0993 141.028 81.1169 140.435C79.1346 139.842 76.9549 144.093 77.5495 146.761C78.1441 149.43 80.9362 153.16 79.9278 156.58C77.9454 163.301 74.7091 163.367 74.7091 163.367C74.7091 163.367 72.4964 162.379 69.1276 165.345C65.7588 168.31 65.0649 169.299 65.0649 169.299C65.0649 169.299 61.4975 172.462 59.1192 173.845C56.7409 175.23 64.2717 164.949 63.6771 159.414C63.0826 153.879 65.6595 139.644 72.0011 137.865C78.3427 136.085 76.7577 137.073 76.7577 137.073C76.7577 137.073 79.9292 129.561 83.0993 127.387C86.2708 125.212 92.2151 123.63 95.5853 123.433C98.954 123.235 105.395 128.87 107.575 131.439C109.754 134.01 111.095 134.686 111.439 135.887C111.835 137.271 111.702 138.393 111.439 139.841H111.437Z",
    fill: "url(#paint7_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0108 160.413C81.0108 160.413 82.1889 162.316 82.1337 161.989C81.9861 161.127 80.5224 157.602 80.997 156.517C81.6619 154.994 81.3322 154.113 81.1308 153.448C80.9556 152.872 79.9375 157.106 79.9375 157.106L81.0121 160.415L81.0108 160.413Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.452 125.89C131.286 125.803 131.209 125.606 131.263 125.427C131.361 125.099 131.522 124.442 132.582 123.841C135.141 122.389 138.961 123.047 139.555 123.541C139.555 123.541 136.843 123.405 134.664 124.492C132.676 125.484 132.198 126.282 131.453 125.89H131.452Z",
    fill: "url(#paint8_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46 126.893C125.46 126.893 124.664 125.513 122.55 125.842C120.909 126.098 118.186 127.193 117.634 128.544C117.634 128.544 120.04 127.492 121.921 127.394C123.804 127.295 125.261 127.883 125.458 126.893H125.46Z",
    fill: "url(#paint9_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.631 154.91C105.631 154.91 105.368 156.18 106.038 156.216C106.88 156.262 106.958 155.236 106.898 155.195L105.632 154.91H105.631Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7954 203.698C50.7954 203.698 43.6605 225.939 43.9585 228.905C44.2551 231.87 41.2836 238.097 46.6334 239.581C51.9845 241.063 66.8474 236.913 70.1182 234.54C73.3877 232.168 63.429 239.73 55.5519 241.658C47.6749 243.586 46.3368 244.623 43.6605 243.437C40.9857 242.251 38.904 236.913 40.9857 226.831C43.066 216.748 48.7151 203.107 48.7151 203.107L50.7954 203.701V203.698Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.326 143.895C145.755 142.72 164.945 146.07 166.927 147.652C168.91 149.233 171.684 161.491 174.458 170.584C177.232 179.678 181.989 189.563 180.8 195.099C180.8 195.099 176.341 191.342 169.206 190.947C164.168 190.668 161.378 206.071 166.405 233.87C166.972 237.004 168.028 245.677 166.134 248.032C166.134 248.032 157.365 247.908 151.271 248.032C136.705 248.327 111.054 252.077 109.951 252.628C108.366 253.419 109.654 201.325 109.654 201.325C109.654 201.325 109.291 185.674 103.346 182.51C97.4 179.346 99.1838 178.029 99.5479 168.705C99.5479 168.705 105.691 160.863 106.285 158.721C106.717 157.164 107.673 152 108.465 150.022C109.258 148.045 120.951 144.684 121.743 146.265C122.536 147.846 120.554 152.986 123.328 158.917C126.102 164.849 130.759 174.337 130.759 174.337C130.759 174.337 143.741 148.241 145.326 143.891V143.895Z",
    fill: "url(#paint10_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.552 145.011C238.025 142.424 233.441 143.684 230.956 145.378C224.885 149.519 211.938 158.335 209.527 159.838C206.355 161.815 194.069 201.353 194.465 203.331C194.861 205.308 217.058 234.963 219.04 230.218C221.022 225.473 223.797 216.775 223.797 216.775C223.797 216.775 229.345 234.172 229.345 235.753C229.345 237.334 235.291 231.799 238.461 233.381C241.632 234.962 256.297 244.847 261.45 245.243C266.603 245.638 265.811 269.758 263.829 273.317C261.846 276.875 332.399 271.339 337.155 263.037C341.912 254.733 337.551 185.144 337.155 179.609C336.759 174.074 330.418 162.607 324.075 158.653C317.733 154.699 293.159 136.906 283.249 134.929C273.34 132.952 253.522 169.329 253.522 169.329C253.522 169.329 243.217 181.981 240.442 176.446C238.134 171.842 244.389 153.21 239.551 145.012L239.552 145.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.913 112.081C217.913 112.081 218.446 108.24 220.428 107.449C222.41 106.658 229.148 115.753 234.499 112.787C239.85 109.822 244.012 108.834 245.993 105.473C247.976 102.112 245.795 105.671 241.237 106.857C236.679 108.044 245.399 105.276 248.173 101.322C250.947 97.3688 249.163 99.345 251.344 102.707C253.524 106.067 256.657 107.412 257.846 109.981C259.035 112.552 259.569 111.758 260.957 109.782C262.345 107.804 257.886 103.893 261.255 100.731C264.624 97.567 267.469 99.1551 268.587 101.719C270.569 106.266 269.975 109.725 269.975 109.725C269.975 109.725 272.452 107.946 271.907 96.6766C271.5 88.2559 267.3 88.6206 263.732 84.0738C260.165 79.527 263.832 79.5766 258.481 76.6109C253.129 73.6453 240.347 68.2577 232.965 72.8059C225.334 77.5068 215.674 83.7284 215.08 90.4509C214.485 97.172 209.94 102.729 213.903 106.879C217.866 111.031 217.916 112.084 217.916 112.084L217.913 112.081Z",
    fill: "url(#paint11_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.757 128.997C271.757 128.997 264.326 139.97 259.271 142.935C254.218 145.901 249.682 151.166 248.372 150.942C244.605 150.299 242.656 147.022 241.897 146.758C241.139 146.494 241.733 153.611 241.733 163.1C241.733 172.588 242.922 177.631 242.922 177.631C242.922 177.631 254.814 161.321 258.083 155.389C261.353 149.458 270.866 135.818 271.757 128.996V128.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.03 158.948L248.916 151.534C246.588 151.386 241.897 146.758 241.897 146.758L242.03 158.948Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.003 155.982C245.003 155.982 244.706 160.727 245.598 161.32C246.489 161.914 241.436 169.031 241.436 169.031L242.921 177.631L252.136 165.472C252.136 165.472 249.758 162.211 250.947 160.727C252.136 159.245 255.109 154.5 255.109 154.5L252.136 149.162C252.136 149.162 247.678 151.83 245.002 155.982H245.003Z",
    fill: "url(#paint12_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.308 157.268L248.917 151.535C248.917 151.535 263.732 139.08 267.892 133.15L272.054 127.219C272.054 127.219 260.361 153.71 255.308 157.268Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.351 126.031C272.351 126.031 283.251 132.752 285.035 133.939C286.818 135.125 281.567 147.678 278.892 149.755C276.217 151.83 268.784 149.459 268.784 149.459L271.757 156.279L243.219 192.458C243.219 192.458 242.823 179.213 242.922 177.631C243.041 175.736 259.569 153.018 272.351 126.033V126.031Z",
    fill: "url(#paint13_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.224 142.935C237.224 142.935 230.733 153.907 230.733 158.948C230.733 163.989 231.625 163.989 231.625 163.989C231.625 163.989 235.787 161.913 237.272 161.616C238.758 161.32 232.219 171.402 232.219 171.402C232.219 171.402 242.623 189.787 243.218 193.05C243.813 196.312 241.896 146.757 241.896 146.757L237.223 142.934L237.224 142.935Z",
    fill: "url(#paint14_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.507 141.035C142.905 141.34 144.045 142.355 144.492 143.712C145.264 146.058 146.213 150.034 145.749 154.496C145.005 161.613 144.263 168.433 145.452 171.102C146.641 173.77 147.087 170.213 147.087 170.213C147.087 170.213 146.343 161.613 147.532 157.461C148.721 153.309 147.236 141.448 144.361 140.245C142.532 139.48 140.918 139.471 140.918 139.471L140.397 140.969L141.507 141.034V141.035Z",
    fill: "url(#paint15_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.464 175.08C108.464 175.08 112.181 188.276 114.707 192.725C117.552 197.734 118.274 198.359 120.949 197.321C123.624 196.284 123.178 195.691 124.516 196.432C125.854 197.174 124.962 197.321 123.178 198.063C121.394 198.805 118.422 199.249 116.787 198.212C115.152 197.174 109.206 183.237 107.721 175.081H108.464V175.08Z",
    fill: "url(#paint16_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.034 173.266C118.034 173.266 121.819 186.371 122.077 191.392C122.368 197.045 122.111 197.924 119.443 198.297C116.775 198.67 116.828 197.949 116.138 199.221C115.448 200.491 116.237 200.196 118.042 199.99C119.846 199.783 122.448 198.76 123.223 197.093C123.999 195.427 121.613 180.63 118.627 172.914L118.034 173.266Z",
    fill: "url(#paint17_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3776 162.181C74.3776 162.181 79.7288 167.716 80.5206 170.682C81.3138 173.647 85.8717 172.263 88.0514 175.427C90.231 178.59 92.6093 186.103 93.2038 188.079C93.7984 190.056 94.1943 179.973 94.9876 179.182C95.7808 178.391 96.5726 178.787 101.131 179.775C105.688 180.763 113.767 196.374 113.568 198.154C113.37 199.933 110.006 210.064 110.006 210.064C110.006 210.064 106.395 206.311 96.5726 209.826C88.5618 212.693 77.1987 218.473 71.0075 220.007C66.9917 221.003 63.6754 222.082 63.6754 222.082C63.6754 222.082 63.2795 218.325 64.0713 214.57C64.8645 210.813 50.4955 205.179 44.3525 208.145C44.3525 208.145 52.5772 180.17 54.7568 177.996C56.9365 175.821 60.7025 170.088 67.0441 166.133C72.0863 162.99 74.0976 162.426 74.3763 162.18L74.3776 162.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8469 213.78C67.6401 210.024 53.2711 204.39 47.1281 207.355C47.1281 207.355 55.3528 179.381 57.5324 177.206C59.712 175.032 63.4781 169.299 69.8197 165.344C71.8131 164.101 73.3306 163.263 74.4577 162.687C74.1611 162.366 73.9817 162.182 73.9817 162.182C73.7031 162.428 71.6904 162.992 66.6496 166.135C60.308 170.089 56.5419 175.822 54.3623 177.998C52.1827 180.172 43.958 208.146 43.958 208.146C50.101 205.181 64.47 210.815 63.6768 214.572C62.8835 218.329 63.2808 222.084 63.2808 222.084C63.2808 222.084 64.5776 221.631 66.4275 221.022C66.3558 220.097 66.1806 216.939 66.8483 213.78H66.8469Z",
    fill: "url(#paint18_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6587 249.727L62.3871 239.43C62.3871 239.43 74.3709 232.662 81.016 228.903C87.6556 225.146 95.1974 221.659 98.2572 220.204C101.792 218.524 105.589 216.447 105.589 216.447C105.589 216.447 107.274 217.336 107.274 223.267C107.274 229.199 109.354 251.587 107.274 253.811C105.49 255.718 75.5849 266.323 65.5075 263.746C63.6673 263.275 61.5235 251.616 61.6573 249.725L61.6587 249.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6154 263.811C64.7751 263.34 63.9529 251.569 64.0868 249.678L64.7158 238.871C64.7158 238.871 76.5796 232.199 83.4441 228.854C90.612 225.361 96.7729 221.675 99.9927 220.616C102.8 219.694 104.963 219.233 106.681 218.838C106.482 217.586 105.64 216.398 105.64 216.398C105.64 216.398 101.843 218.474 98.3083 220.155C95.2486 221.61 87.7054 225.097 81.0672 228.854C74.4221 232.614 62.4382 239.382 62.4382 239.382C62.4382 239.382 61.6657 246.796 61.5319 250.066C61.4546 251.96 62.6355 265.743 64.4744 266.214C65.7298 266.534 71.2906 264.616 73.2371 263.812C72.4714 263.763 67.2527 263.976 66.6154 263.812V263.811Z",
    fill: "url(#paint19_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.425 171.967C145.425 171.967 144.236 175.526 145.92 176.119C147.605 176.712 148.993 174.241 149.488 172.362C149.983 170.484 149.289 169.792 148.002 169.99C146.714 170.188 145.425 171.967 145.425 171.967Z",
    fill: "url(#paint20_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.047 171.276C149.737 170.397 150.831 169.903 151.941 170.032C152.504 170.098 153.092 170.321 153.602 170.832C155.088 172.314 155.631 174.835 153.65 177.898C151.668 180.963 147.474 180.612 146.78 178.438C146.087 176.263 146.615 174.734 147.607 173.252C148.114 172.493 148.648 171.785 149.047 171.276Z",
    fill: "url(#paint21_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 154.469C105.085 154.394 105.371 154.534 105.458 154.568C105.863 154.728 106.886 155.01 107.609 154.928C108.522 154.824 107.152 155.499 106.499 155.395C105.953 155.309 105.407 154.82 105.244 154.665C105.212 154.634 105.203 154.596 105.214 154.557L105.061 154.469H105.062Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.414 192.23C136.905 191.572 169.548 189.463 171.784 189.659C174.02 189.856 137.431 231.571 136.212 232.56C134.992 233.548 96.3712 238.094 96.574 236.91C96.7768 235.723 124.913 207.65 136.414 192.23Z",
    fill: "url(#paint22_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.102 210.767C106.434 209.281 105.648 209.123 106.58 208.797C109.59 207.745 115.526 216.275 114.774 217.025C113.784 218.013 107.442 224.932 107.442 224.932C107.442 224.932 108.825 214.597 107.103 210.766L107.102 210.767Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0359 167.519C68.0359 167.519 74.2782 174.339 74.4272 180.419C74.5762 186.499 76.9544 186.35 76.9544 186.35C76.9544 186.35 76.8054 181.012 79.7783 178.937C82.7511 176.862 84.3859 175.971 85.873 176.862C87.3587 177.751 90.6295 185.906 92.1153 188.427C93.601 190.948 93.899 189.613 93.899 189.613C93.899 189.613 90.0846 177.356 88.5479 175.33C87.0125 173.303 81.2654 171.079 78.8871 167.373C76.5088 163.666 74.3789 162.184 74.3789 162.184C74.3789 162.184 66.4025 164.112 68.0373 167.522L68.0359 167.519Z",
    fill: "url(#paint23_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8777 184.26C76.1755 183.951 74.9298 182.788 74.8236 178.441C74.6746 172.361 68.4323 165.541 68.4323 165.541C68.3316 165.332 68.2681 165.128 68.2364 164.93C67.6474 165.616 67.4046 166.417 67.8377 167.32C67.8377 167.32 74.08 174.14 74.229 180.22C74.378 186.3 76.7563 186.151 76.7563 186.151C76.7563 186.151 76.7342 185.356 76.8777 184.26Z",
    fill: "url(#paint24_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.512 186.447C91.0263 183.926 87.7555 175.771 86.2697 174.882C84.784 173.993 83.1479 174.882 80.175 176.958C78.7914 177.924 78.0837 179.597 77.7236 181.109C78.1389 180.186 78.7334 179.329 79.5805 178.737C82.5533 176.662 84.188 175.771 85.6751 176.662C87.1609 177.551 90.4317 185.706 91.9174 188.227C93.4032 190.748 93.7012 189.413 93.7012 189.413C93.7012 189.413 93.4253 188.524 92.9907 187.188C92.8472 186.988 92.6872 186.746 92.512 186.447Z",
    fill: "url(#paint25_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4274 189.297C94.4274 189.297 95.5007 184.849 96.5408 183.959C97.581 183.07 98.2583 182.047 99.2985 184.271C100.339 186.495 100.784 187.386 100.784 187.386C100.784 187.386 99.893 182.047 99.0005 180.417C98.6322 179.744 98.239 179.197 97.9038 178.787C97.4099 178.182 95.6993 178.099 95.1847 178.687C94.7461 179.188 94.3915 180.437 94.3915 181.454C94.3915 183.678 91.4518 192.114 94.4246 189.296L94.4274 189.297Z",
    fill: "url(#paint26_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.094 234.538C126.895 233.945 125.706 232.364 128.084 229.991C130.462 227.619 133.435 228.805 135.615 226.828C137.794 224.85 141.163 222.874 140.371 225.641C139.578 228.409 138.488 233.549 137.349 233.451C136.535 233.381 136.259 234.637 135.07 234.637C133.881 234.637 133.485 234.439 132.692 235.429C131.898 236.418 131.304 235.627 130.313 235.429C129.323 235.23 129.619 236.22 128.43 236.022C127.241 235.824 127.092 234.54 127.092 234.54L127.094 234.538Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.582 210.221C166.582 210.221 164.353 209.628 163.758 211.703C163.164 213.778 164.649 220.007 162.867 222.082C161.083 224.157 164.734 230.056 166.963 230.946C169.192 231.836 167.475 214.52 166.583 210.221",
    fill: "#FFD4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.368 193.979C163.365 193.311 168.53 209.795 169.125 210.388C169.719 210.981 172.692 208.807 172.692 208.807C172.692 208.807 167.341 195.956 164.368 193.98V193.979Z",
    fill: "url(#paint27_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.397 131.193C121.397 131.193 122.04 131.735 122.436 131.669C122.832 131.603 123.096 131.404 123.36 131.142C123.625 130.877 123.69 130.482 123.69 130.482L121.396 131.193H121.397Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.955 127.813C134.955 127.813 135.517 128.671 136.507 128.34C137.009 128.174 137.379 127.051 137.3 127.286C137.3 127.286 135.781 127.846 134.955 127.813Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.289 143.252L121.199 142.115C120.019 142.536 116.096 146.168 115.006 147.749C113.123 150.481 111.29 162.032 111.142 165.74C110.993 169.447 108.318 167.668 107.873 170.633C107.427 173.599 107.096 175.477 107.245 175.922C107.394 176.366 109.161 175.593 109.161 175.593C109.161 175.593 109.211 171.079 111.291 170.486C113.372 169.893 115.304 169.151 116.791 171.968C118.277 174.785 117.386 174.043 117.386 174.043L119.466 173.417C119.466 172.231 116.692 167.486 114.413 167.519C111.78 167.558 114.775 154.177 115.503 151.604C116.791 147.057 121.062 144.576 122.29 143.251L122.289 143.252Z",
    fill: "url(#paint28_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.142 194.43C168.142 194.43 167.547 195.912 164.873 196.061C162.198 196.209 157.441 199.62 158.481 200.361C159.521 201.103 159.67 204.513 161.603 203.92C163.536 203.327 171.711 193.541 168.143 194.43H168.142Z",
    fill: "#FFE3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.799 62.1312C328.122 62.1312 319.434 53.2014 319.434 42.2238C319.434 31.2463 328.12 22.3164 338.799 22.3164C349.478 22.3164 358.165 31.2463 358.165 42.2238C358.165 53.2014 349.478 62.1312 338.799 62.1312ZM338.799 25.5916C329.932 25.5916 322.717 33.0531 322.717 42.2252C322.717 51.3972 329.932 58.8587 338.799 58.8587C347.667 58.8587 354.882 51.3972 354.882 42.2252C354.882 33.0531 347.667 25.5916 338.799 25.5916Z",
    fill: "url(#paint29_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1464 96.6916C66.3669 96.6916 64.5514 96.3944 62.7732 95.7668C58.8127 94.3714 55.615 91.5682 53.7692 87.8732C51.9179 84.1659 51.6475 80.0071 53.0091 76.1608C55.8329 68.1874 65.8551 63.5525 74.037 66.4355C77.9369 67.8103 80.9552 70.747 82.5361 74.7076C84.0177 78.4204 84.0826 82.7649 82.7155 86.6292C80.5193 92.8329 74.5598 96.6916 68.1464 96.6916ZM68.9686 67.8117C63.0657 67.8117 57.0234 71.4956 55.1101 76.9012C53.9513 80.1737 54.183 83.7186 55.7626 86.8824C57.349 90.0586 60.1011 92.4696 63.514 93.6723C70.5454 96.1508 78.2169 92.6581 80.6145 85.8888C81.805 82.5255 81.7512 78.7493 80.4669 75.5291C79.1274 72.1727 76.5808 69.6874 73.2962 68.53C71.907 68.0401 70.442 67.8103 68.9686 67.8103V67.8117Z",
    fill: "url(#paint30_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.993 231.633C354.515 231.633 350.872 227.888 350.872 223.285C350.872 218.682 354.515 214.938 358.993 214.938C363.471 214.938 367.114 218.682 367.114 223.285C367.114 227.888 363.471 231.633 358.993 231.633ZM358.993 216.31C355.274 216.31 352.249 219.439 352.249 223.285C352.249 227.132 355.274 230.261 358.993 230.261C362.712 230.261 365.738 227.132 365.738 223.285C365.738 219.439 362.712 216.31 358.993 216.31Z",
    fill: "url(#paint31_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.445 48.241H161.362V41.7855H154.981V39.7075H161.362V33.4336H163.445V39.7075H169.825V41.7855H163.445V48.241Z",
    fill: "url(#paint32_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.795 214.781L27.8209 214.697V210.046H22.249V207.598H27.8209V202.119H30.3647L29.8874 207.598H35.3696V210.046H30.195L29.795 214.781Z",
    fill: "url(#paint33_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.061 127.209L350.088 127.126V122.474H344.517V120.027H350.088V114.547H352.632L352.155 120.027H357.637V122.474H352.463L352.061 127.209Z",
    fill: "url(#paint34_linear_2307_32161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.563 205.66C111.563 205.66 112.768 214.217 111.965 214.418C111.162 214.618 110.009 210.064 110.009 210.064L111.563 205.66Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.436 203.331C154.436 203.331 193.416 200.761 194.072 201.75C208.737 223.892 225.682 234.567 225.682 234.567C225.682 234.567 207.861 228.128 209.481 231.899C210.819 235.013 213.048 237.237 213.048 237.237C213.048 237.237 209.332 237.336 208.936 239.51C208.54 241.685 211.786 245.157 212.008 245.541C212.999 247.254 211.122 248.096 211.843 250.253C212.041 250.846 193.479 253.35 193.479 253.35C193.479 253.35 159.589 215.788 154.437 203.333L154.436 203.331Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2307_32161",
    x1: 184.702,
    y1: 383.454,
    x2: 212.26,
    y2: 11.1231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BC777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6AC67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#69C58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#66C3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#63C0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2307_32161",
    x1: 285.142,
    y1: 290.881,
    x2: 285.716,
    y2: 168.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2307_32161",
    x1: 259.056,
    y1: 144.65,
    x2: 240.464,
    y2: 112.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2307_32161",
    x1: 243.931,
    y1: 153.353,
    x2: 225.339,
    y2: 121.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2307_32161",
    x1: 116.171,
    y1: 82.2852,
    x2: 141.343,
    y2: 161.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6F8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D1F5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C2EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AAE2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2307_32161",
    x1: 134.89,
    y1: 114.466,
    x2: 139.032,
    y2: 160.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2307_32161",
    x1: 120.74,
    y1: 115.728,
    x2: 124.882,
    y2: 162.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2307_32161",
    x1: 42.5209,
    y1: 201.423,
    x2: 79.43,
    y2: 153.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2307_32161",
    x1: 134.275,
    y1: 119.557,
    x2: 138.619,
    y2: 138.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2307_32161",
    x1: 120.408,
    y1: 122.657,
    x2: 124.753,
    y2: 142.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2307_32161",
    x1: 175.711,
    y1: 0.477044,
    x2: 135.472,
    y2: 206.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C7E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8E3E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A0D9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7FCBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2307_32161",
    x1: 210.6,
    y1: -17.0499,
    x2: 242.96,
    y2: 103.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2307_32161",
    x1: 232.197,
    y1: 106.336,
    x2: 246.994,
    y2: 159.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2307_32161",
    x1: 296.422,
    y1: 301.063,
    x2: 207.061,
    y2: -83.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2307_32161",
    x1: 271.575,
    y1: 306.839,
    x2: 182.214,
    y2: -77.5809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2307_32161",
    x1: 140.397,
    y1: 155.784,
    x2: 147.943,
    y2: 155.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2307_32161",
    x1: 103.073,
    y1: 147.911,
    x2: 133.263,
    y2: 236.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2307_32161",
    x1: 104.15,
    y1: 148.18,
    x2: 134.34,
    y2: 236.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2307_32161",
    x1: 106.054,
    y1: 202.85,
    x2: 23.2451,
    y2: 179.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2307_32161",
    x1: 110.367,
    y1: 275.632,
    x2: 66.8154,
    y2: 216.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2307_32161",
    x1: 135.011,
    y1: 137.006,
    x2: 165.201,
    y2: 225.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2307_32161",
    x1: 138.299,
    y1: 139.259,
    x2: 166.196,
    y2: 220.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2307_32161",
    x1: 299.336,
    y1: 226.898,
    x2: 118.601,
    y2: 211.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2307_32161",
    x1: 118.992,
    y1: 341.474,
    x2: 29.631,
    y2: -42.9455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2307_32161",
    x1: 84.4581,
    y1: 157.928,
    x2: 69.0523,
    y2: 180.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2307_32161",
    x1: 97.8052,
    y1: 166.958,
    x2: 82.3994,
    y2: 189.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2307_32161",
    x1: 132.343,
    y1: 339.632,
    x2: 42.2088,
    y2: -48.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2307_32161",
    x1: 172.601,
    y1: 171.451,
    x2: 168.263,
    y2: 203.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2307_32161",
    x1: 107.207,
    y1: 159.087,
    x2: 122.289,
    y2: 159.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2307_32161",
    x1: 333.414,
    y1: 23.0967,
    x2: 344.136,
    y2: 61.3646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2307_32161",
    x1: 83.259,
    y1: 76.9452,
    x2: 52.8366,
    y2: 85.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFEFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B9ECE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ABE4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#92D8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#70C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C08B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2307_32161",
    x1: 356.735,
    y1: 215.264,
    x2: 361.231,
    y2: 231.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2307_32161",
    x1: 154.981,
    y1: 40.8373,
    x2: 169.825,
    y2: 40.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFEFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B9ECE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ABE4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#92D8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#70C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C08B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2307_32161",
    x1: 22.249,
    y1: 208.449,
    x2: 35.3696,
    y2: 208.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2307_32161",
    x1: 344.517,
    y1: 120.879,
    x2: 357.637,
    y2: 120.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2307_32161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 283,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.16eddd41e910ee6547e9889dccd89700.svg";
export { ForwardRef as ReactComponent };